import { VendorProfile } from "../../auth/vendor-profile";
import { RoleGroup } from "../../types/auth/role-group";
import { UserType } from "../../types/auth/user-type";
import { CompanyParameter } from "../company-parameter";
import { UserProfile } from "./user-profile";
import { CompanyProfile } from '../../../company/models/company/company-profile';

export class Session {
    isInitialized = false;
    displayName?: string;
    email?: string;
    accessToken?: string;
    refreshToken?: string;
    userProfile?: UserProfile;
    userType?: UserType;
    roles!: RoleGroup[];
    vendorProfile?: VendorProfile;
    companyProfile?: CompanyProfile;
    companyParameters?: CompanyParameter[];
}
